import React from 'react'
import { Link } from 'react-router-dom'
import { FiAlertTriangle } from 'react-icons/fi'

class ContentErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('Superadmin page crashed inside the dashboard shell', error, info)
  }

  componentDidUpdate(previousProps) {
    if (this.state.error && previousProps.resetKey !== this.props.resetKey) this.setState({ error: null })
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <div role='alert' className='tw-mx-auto tw-flex tw-max-w-xl tw-flex-col tw-items-center tw-gap-3 tw-rounded-2xl tw-bg-white tw-px-6 tw-py-10 tw-text-center tw-shadow-card'>
        <FiAlertTriangle aria-hidden='true' className='tw-h-14 tw-w-14 tw-text-danger' />
        <h2 className='tw-font-heading tw-text-[20px] tw-font-semibold tw-text-ink'>Something went wrong on this page</h2>
        <p className='tw-text-[14px] tw-text-inkSoft'>The rest of superadmin is still available.</p>
        <Link to='/' className='tw-mt-2 tw-inline-flex tw-h-10 tw-items-center tw-rounded-[10px] tw-bg-ember tw-px-4 tw-text-[14px] tw-font-semibold tw-text-white hover:tw-bg-emberDeep'>Go to Overview</Link>
      </div>
    )
  }
}

export default ContentErrorBoundary
